import React, { Component } from 'react';

const OidcSettings = {
  authority: "https://login.idaman.pertamina.com",
  client_id: "4a94f581-a16c-4360-9cf1-c98997929c6e",
  redirect_uri: 'https://app.edtp.pertamina.com/pages/login',
  response_type: 'token id_token',
  scope: 'openid api.auth user.read user.role profile email application.read application.readAll',
  post_logout_redirect_uri: 'https://app.edtp.pertamina.com/pages/login'
};

const createRandomValue = () => (
  Math.random().toString(36).slice(2) + Date.now().toString(36)
);

const buildAuthorizeUrl = () => {
  const params = [
    ['client_id', OidcSettings.client_id],
    ['redirect_uri', OidcSettings.redirect_uri],
    ['response_type', OidcSettings.response_type],
    ['scope', OidcSettings.scope],
    ['state', createRandomValue()],
    ['nonce', createRandomValue()]
  ].map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&');

  return `${OidcSettings.authority}/connect/authorize?${params}`;
};

class LoginPageIdaman extends Component {
  componentDidMount() {
    const urls = window.location.href;
    const urlnya = urls.split("login#");

    if (urlnya[1] === "logout") {
      return;
    }

    window.location.replace(buildAuthorizeUrl());
  }

  render() {
    return null;
  }
}

export default LoginPageIdaman;
